import React from 'react';
import { components } from 'react-select';

const CustomMultiValueLabel = props => (
  <components.MultiValueLabel {...props}>
    <img src={props.selectProps.multiIcon} alt="" />
    <div className="custom-label">{props.children}</div>
  </components.MultiValueLabel>
  );
export default CustomMultiValueLabel;
